<template>
  <div class="database-container">
    <a-card class="content-card">
      <div class="card-header">
        <a-icon type="history" class="header-icon" />
        <div class="header-title">{{ translate('integral.title') }}</div>
      </div>
      
      <a-table
        :columns="columns"
        :data-source="dataList"
        :loading="dataLoading"
        :rowKey="(record, index) => index"
        :pagination="pagination"
        @change="handleTableChange"
        class="modern-table"
      >
        <template slot="payIntegralChang" slot-scope="text">
          <span :class="text > 0 ? 'positive' : (text < 0 ? 'negative' : '')">
            {{ text > 0 ? '+' + text : text }}
          </span>
        </template>
        <template slot="giveIntegralChang" slot-scope="text">
          <span :class="text > 0 ? 'positive' : (text < 0 ? 'negative' : '')">
            {{ text > 0 ? '+' + text : text }}
          </span>
        </template>
        <template slot="allIntegralChang" slot-scope="text">
          <span :class="text > 0 ? 'positive' : (text < 0 ? 'negative' : '')">
            {{ text > 0 ? '+' + text : text }}
          </span>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
export default {
  name: 'IntegralChange',
  inject: ['languageState'],
  data() {
    return {
      uid: localStorage.getItem('userId'),
      dataList: [],
      dataLoading: false,
      pagination: {
        defaultPageSize: 10,
        total: 0,
        defaultCurrent: 1,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => this.translate('integral.total', { total }),
      },
    };
  },
  computed: {
    currentLanguage() {
      return this.languageState ? this.languageState.languageCode : 'zh';
    },
    columns() {
      return [
        {
          title: this.translate('integral.uid'),
          dataIndex: 'uid',
          key: 'uid',
          align: 'center',
        },
        {
          title: this.translate('integral.payIntegralChang'),
          dataIndex: 'payIntegralChang',
          key: 'payIntegralChang',
          align: 'center',
          scopedSlots: { customRender: 'payIntegralChang' },
        },
        {
          title: this.translate('integral.giveIntegralChang'),
          dataIndex: 'giveIntegralChang',
          key: 'giveIntegralChang',
          align: 'center',
          scopedSlots: { customRender: 'giveIntegralChang' },
        },
        {
          title: this.translate('integral.allIntegralChang'),
          dataIndex: 'allIntegralChang',
          key: 'allIntegralChang',
          align: 'center',
          scopedSlots: { customRender: 'allIntegralChang' },
        },
        {
          title: this.translate('integral.creatTime'),
          dataIndex: 'creatTime',
          key: 'creatTime',
          align: 'center',
        },
      ];
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    translate(key, params = {}) {
      const lang = this.currentLanguage;
      const translations = {
        'integral.title': lang === 'zh' ? '积分变动明细' : 'Points Change Details',
        'integral.uid': lang === 'zh' ? '用户ID' : 'User ID',
        'integral.payIntegralChang': lang === 'zh' ? '改变的充值积分' : 'Changed Recharge Points',
        'integral.giveIntegralChang': lang === 'zh' ? '改变的赠送积分' : 'Changed Gift Points',
        'integral.allIntegralChang': lang === 'zh' ? '改变的总积分' : 'Changed Total Points',
        'integral.creatTime': lang === 'zh' ? '创建时间' : 'Creation Time',
        'integral.total': lang === 'zh' ? `共 ${params.total} 条` : `Total ${params.total} items`,
      };
      return translations[key] || key;
    },
    getList() {
      this.dataLoading = true;
      this.$request.post('/userIntegral/consumeDetail', {
        userType: "proxylink",
      }).then(res => {
        if (res.data.code === 200) {
          const result = res.data.result || res.data.data;
          let listData = result.list || result.records || result || [];
          
          // 对列表数据进行按创建时间倒序排列
          this.dataList = Array.isArray(listData) 
            ? listData.sort((a, b) => new Date(b.creatTime).getTime() - new Date(a.creatTime).getTime()) 
            : [];
          
          this.pagination = {
            ...this.pagination,
            total: result.total || this.dataList.length,
          };
        } else {
          this.$message.warning(res.data.msg || '获取数据失败');
        }
      }).catch(err => {
        console.error(err);
      }).finally(() => {
        this.dataLoading = false;
      });
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getList();
    }
  }
};
</script>

<style scoped lang="less">
.database-container {
  padding: 24px;
  background: #f5f5f5;
  min-height: 100%;
}

.content-card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  background: #fff;
  border: 1px solid #f0f0f0;
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid #f0f0f0;

  .header-icon {
    font-size: 24px;
    color: #1890ff;
    margin-right: 16px;
  }

  .header-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }
}

.modern-table {
  :deep(.ant-table-thead > tr > th) {
    background: #fafafa;
    font-weight: 600;
    border-bottom: 2px solid #f0f0f0;
  }

  :deep(.ant-table-tbody > tr:hover > td) {
    background: #e6f7ff;
  }
}

.positive {
  color: #52c41a;
  font-weight: 600;
}

.negative {
  color: #f5222d;
  font-weight: 600;
}
</style>
